module.exports = __webpack_public_path__ + "static/img/ubi_desk_logo1.9c8e8378.png";